module.exports = CLIENT_CONFIG; // eslint-disable-line



//////////////////
// WEBPACK FOOTER
// ./src/client/config.js
// module id = 81
// module chunks = 0